import { tourStep } from './tourRegistry';

export const bandaPerfilSteps = [
  tourStep(
    'completitud',
    'Completitud y validación',
    'Esta barra marca lo que falta en el perfil. Al completar los datos <strong>obligatorios</strong> se genera un código de validación: envíalo por mensaje directo a nuestras redes. No hace falta rellenar el 100% para validarte.',
  ),
  tourStep(
    'tabs',
    'Secciones del perfil',
    'Aquí está el <strong>perfil público</strong>, <strong>avales</strong>, <strong>reseñas</strong>, <strong>Tu Web</strong> (micrositio), datos <strong>privados</strong> y la <strong>suscripción</strong> (plan, IA y disco).',
  ),
  tourStep(
    'info-basica',
    'Información básica',
    'Nombre, bio, avatar y fondo. Es lo primero que verán cofradías y visitantes del perfil público.',
  ),
  tourStep(
    'localizacion',
    'Tu ubicación',
    'Sirve para aparecer en búsquedas por distancia en Comunidad. El desplazamiento privado (si lo activas) no se publica.',
    'top',
  ),
  tourStep(
    'especialidades',
    'Especialidades musicales',
    'Estilos y tipos de evento. Las cofradías pueden filtrar por esto al buscaros.',
    'top',
  ),
  tourStep(
    'repertorio',
    'Repertorio de vitrina',
    'Lista de marchas visible en el perfil público. El archivo de partituras (IA, voces, compartir) está en <strong>Gestión → Archivo musical</strong>; desde aquí puedes importar obras de ese archivo.',
    'top',
  ),
  tourStep(
    'galeria',
    'Galería de fotos',
    'Fotos de actuaciones y ensayos. Un perfil con imágenes genera más confianza.',
    'top',
  ),
  tourStep(
    'previsualizar',
    'Previsualizar y compartir',
    'Mira el perfil como lo ven los demás y, si quieres, copia el enlace público con el botón de compartir.',
  ),
];
